import React, { useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import ReactECharts from 'echarts-for-react';
import 'echarts-wordcloud';
import maybeFormatDate from './maybeFormatDate';
import { removeStopwords } from 'stopword';

const WordCloudChart = ({ data, colours, chartHeight = 300, inputType = null }) => {
    const ref = useRef(null);
    const theme = useTheme();

    const splitData = data
        .flatMap(item => Array(item.value).fill(item.name))
        .flatMap(text => {
            const { str, isDate } = maybeFormatDate(text, inputType);

            let isNumber = Boolean(!isDate && typeof str === 'number');

            // Cast this mystery meat into string
            const string = String(str);

            // if date, dateTime or number, split on whitespace only.
            // Allow apostrophes for strings
            const regex = (isDate || isNumber) ? /\s+/ : /[^a-zA-Z0-9']+/;

            const splitString = removeStopwords(string.split(regex));

            return splitString;
        });

    const counts = splitData.reduce((acc, word) => {
        acc[word] = (acc[word] || 0) + 1;

        return acc;
    }, {});

    const formattedCounts = Object.entries(counts)
        .map(([name, value]) => ({ name, value }));

    const formattedData = formattedCounts
        .map((e, i) => ({
            ...e,
            textStyle: {
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 'bold',
                color: colours[i]
            }
        }));

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: params => `${params.marker}${params.name}: <b>${params.value}</b>`
        },
        series: [{
            type: 'wordCloud',
            shape: 'diamond',
            keepAspect: false,
            left: 'center',
            top: 'center',
            width: '100%',
            height: '100%',
            right: null,
            bottom: null,
            sizeRange: [12, 60],
            rotationRange: [-0, 0],
            rotationStep: 45,
            gridSize: 8,
            drawOutOfBound: false,
            shrinkToFit: true,
            layoutAnimation: true,
            emphasis: {
                focus: 'self',
                textStyle: {
                    color: theme.palette.text.main
                }
            },
            data: formattedData
        }]
    };

    const height = Boolean(chartHeight >= 300) ? chartHeight : 300;

    return (
        <ReactECharts
            option={options}
            style={{ height }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default WordCloudChart;
